// Polyfill for sockjs-client - must be before any imports
(window as Window & typeof globalThis & { global: Window }).global = window;
import('./bootstrap').catch((err) => console.error(err));
